import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Loader from '../../components/common/Loader';

import CentralizeButton from './CentralizeButton';

interface Props {
  onClick: VoidFunction;
  isFetching?: boolean;
}

function LoadMoreButton({ isFetching, onClick }: Props) {
  const { t } = useTranslation('common');
  if (isFetching) return <Loader />;

  return (
    <CentralizeButton
      onClick={onClick}
      style={{ marginBottom: '40px' }}
      text={t('common:loadMore')}
      outline
      size="sm"
    />
  );
}

export default React.memo(LoadMoreButton);
